import ProfileLogo from '@components/ProfileLogo'
import { StyledAltLogoWrapper } from '@components/ProfileLogo/index.styles'
import Button from '@components/formControls/Button'
import { ResultProfileLogo } from '@modules/search/components/ResultsSection/components/ResultProfileList.styles'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { Badge } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { css, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const StyledProfileWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const NewAssetsBadge = styled(Badge)`
  height: 18px;
  min-width: 10px;
  color: #fff;
  background-color: #e22758;
  padding: 6px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 400;
  display: flex;
  margin-left: 10px;
  align-items: center;
  justify-content: center;
`

export const StyledProfileWrapperInner = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`

export const ProfileViewportWrapper = styled('div')`
  width: 100%;
  height: 100%;
  overflow: auto;
  margin: ${componentSizes.smDistance} 0;
`

export const ProfileWrapper = styled('div')`
  display: flex;
  flex-direction: row;
`

export const ProfileOuterWrapper = styled('div')`
  max-width: ${componentSizes.maxContentSectionWidth};
  width: 100%;

  ${(props: { customMaxWidth?: string }) =>
    props.customMaxWidth
      ? css`
          max-width: ${props.customMaxWidth};
        `
      : ''}
`

export const ProfileWrapperInner = styled('div')`
  flex: 1;
`

export const ProfileContentWrapper = styled('div')`
  padding: ${componentSizes.mdDistance};
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  ${(props: { isFetching?: boolean; isError?: boolean }) => {
    if (props.isFetching) {
      return `
        margin-right: 301px;
      `
    }
    if (props.isError) {
      return `
        margin-right: 301px;
        align-items: center;
      `
    }
    return ''
  }}
`

export const ProfileTitleWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`

export const ProfileTitleInner = styled('div')`
  width: 75%;
  display: flex;
  flex-direction: column;
  ${(props: { fullWidth?: boolean }) =>
    props.fullWidth
      ? css`
          width: 100%;
        `
      : ''}
`

export const ProfileTitle = styled('div')`
  position: relative;
  display: flex;
  flex-direction: row;
`

export const ProfileLogoWrapper = styled('div')`
  flex: 0 0 65px;
  margin-right: 12px;
  padding-top: 8px;
  display: flex;
  align-items: flex-start;
  ${(props: { emptySection?: boolean; isDelegate?: boolean; isDefaultLogo?: boolean }) => {
    if (props.emptySection) {
      return `
        flex: 0 0 47px;
        padding-top: 0;
      `
    }
    if (props.isDelegate) {
      return `
        flex: 0 0 90px;
      `
    }
    if (props.isDefaultLogo) {
      return `
        flex: 0 0 43px;
        padding-top: 4px;
      `
    }
    return ''
  }}
`

export const ProfileLogoInner = styled('div')`
  aspect-ratio: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

export const DelegateDefaultLogo = styled('div')`
  width: 43px;
  height: 43px;
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${colors.lightGrey};
`

export const ProfileTypeLogo = styled(ResultProfileLogo)`
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
`

export const ProfileName = styled(Typography)`
  font-size: 32px;
  padding-top: 4px;
  word-break: break-word;
`

export const ProfileEventInfo = styled(Typography)`
  font-size: 18px;
  line-height: 18px;

  ${(props: { $isDelegate?: boolean }) =>
    props.$isDelegate
      ? css`
          min-width: 360px;
          max-width: 650px;
          margin-right: 200px;
          border-top: 1px solid ${colors.lightGrey};
          margin-top: 14px;
          padding-top: 14px;
        `
      : ''}
`

export const ProfileEventName = styled('span')`
  padding-left: 10px;
  margin-left: 10px;
  border-left: 1px solid ${colors.bodyText};
`

export const ProfileTitleButtons = styled('div')`
  width: 305px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const ProfileContent = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: ${componentSizes.mdDistance};
`

export const ProfileEmptySection = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
`

export const ProfileEmptySectionMessage = styled(Typography)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 284px;
  padding: 15px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
  position: relative;
  line-height: 20px;
`

export const ProfileSkeleton = styled(Skeleton)`
  width: 98%;
  height: 20px;
  margin-bottom: ${componentSizes.mdDistance};
  border-radius: 4px;
`

export const ProfileMainColumn = styled('div')`
  flex: 1;
  min-width: 360px;
  max-width: 678px;
  word-break: break-word;
`

export const ProfileOtherInfo = styled('div')`
  width: ${componentSizes.otherInfoSectionWidth};
  padding-left: ${componentSizes.smDistance};
  word-break: break-word;
`

export const ProfileSection = styled('div')`
  word-break: break-word;
  position: relative;
  & + & {
    margin-top: ${componentSizes.smDistance};
  }
  ${(props: { isUpdated?: boolean }) =>
    props.isUpdated
      ? css`
          border: 1px solid ${colors.primary};
        `
      : ''}
`

export const ProfileSectionTitle = styled(Typography)`
  padding: 2px 8px;
  margin-bottom: ${componentSizes.smDistance};
  border-left: 3px solid ${colors.pink};
  background-color: ${colors.commonGrey};
`

export const SubsectionContent = styled('div')`
  position: relative;
  margin-bottom: 14px;
  ${(props: { isUpdated?: boolean }) =>
    props.isUpdated
      ? css`
          border: 1px solid ${colors.primary};
        `
      : ''}
  ${(props: { noBottomMargin?: boolean }) =>
    props.noBottomMargin
      ? css`
          margin-bottom: 0;
        `
      : ''}
`

export const SubsectionContentInner = styled('div')`
  > p:first-child {
    margin-top: 0;
  }
`

export const SubsectionTitle = styled(Typography)`
  margin-bottom: 3px;
`

export const UpdatedLabel = styled('div')`
  ${(props: { isAbsolute?: boolean }) =>
    props.isAbsolute
      ? css`
          position: absolute;
          left: 0;
          bottom: 0;
        `
      : ''}
  padding: 0 4px;
  width: fit-content;
  background-color: ${colors.primary};
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  color: ${colors.white};
`

export const UpdatedCountBadge = styled(Badge)`
  height: 16px;
  min-width: 13px;
  color: #fff;
  background-color: #e22758;
  padding: 2px 4px 2px 4px;
  border-radius: 66px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -7px;
  top: -6px;
  z-index: 1;
  cursor: default;
`

export const StyledSocialIcon = styled('img')`
  width: 25px;
  height: 25px;
  & + & {
    margin-left: 6px;
  }
`

export const CompanyCardWrap = styled('div')`
  flex: 0 0 auto;
  width: ${componentSizes.profileRightColumnWidth};
  margin-left: ${componentSizes.smDistance};
`

export const CompanyCardInner = styled('div')`
  padding: ${componentSizes.mdDistance};
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const CompanyCardTitleWrap = styled('div')`
  display: flex;
  align-items: center;
`

export const StyledProfileLogo = styled(ProfileLogo)`
  margin-right: 12px;
  ${StyledAltLogoWrapper} {
    border: 2px solid ${colors.black};
    border-radius: 50%;
  }
`

export const StyledHeaderProfileLogo = styled(ProfileLogo)`
  margin-right: 12px;
  margin-top: 8px;
  position: relative;
  ${StyledAltLogoWrapper} {
    top: 1px;
    background-color: ${colors.lightGrey};
    border-radius: 50%;
    font-weight: 700;
    font-size: 20px;
  }
`

export const CompanyCardTitle = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
`

export const CompanyCardName = styled(CompanyCardTitle)`
  font-size: 24px;
  line-height: 24px;
  margin: 12px 0;
  cursor: pointer;
`

export const CompanyProfileButtonWrapper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

export const CompanyContactButton = styled(Button)`
  margin-bottom: 12px;
  align-self: flex-start;
`

export const CompanyProfileButton = styled(Button)`
  align-self: flex-end;
  margin-top: auto;
`

export const SkeletonWrap = styled('div')`
  width: 100%;
  & + & {
    margin-top: 12px;
  }
`

export const ProfilesOverviewWrapper = styled('div')`
  padding-top: 38px;
  position: relative;
`

export const ProfilesOverviewTitle = styled(ProfileName)`
  padding-bottom: 12px;
  border-bottom: 1px solid #cccccc;
  margin-bottom: ${componentSizes.smDistance};
`

export const ProfilesOverviewSubTitle = styled(ProfileName)`
  font-size: 20px;
  line-height: 26px;
  padding: 0;
`

export const ProfilesOverviewHead = styled('div')`
  padding-left: ${componentSizes.smDistance};
  margin-bottom: ${componentSizes.mdDistance};
`

export const LoadMoreAncher = styled('div')`
  position: absolute;
  bottom: 400px;
  height: 20px;
  opacity: 0;
`

export const ProfilesOverviewButtonWrapper = styled('div')`
  display: flex;
  justify-content: end;
  padding: 6px 0;
  margin-bottom: 10px;
`

export const StyledKeyboardArrowLeftIcon = styled(KeyboardArrowLeftIcon)`
  font-size: 20;
  padding: 0;
`

export const NavigationContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: ${componentSizes.maxContentSectionWidth};
`

export const GoToLatestCompanyAssetsButtonText = styled('div')`
  color: ${colors.primaryDark};
`

export const GoToLatestCompanyAssetsButtonIcon = styled('div')`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background: ${colors.primary};
  align-items: center;
  justify-content: center;
`

export const GoToLatestCompanyAssetsButtonMuiIcon = styled(KeyboardArrowLeftIcon)`
  color: ${colors.white};
  margin-left: -1px;
  transform: rotate(-90deg);
`

export const StyledProfileContactButton = styled(Button)`
  margin-left: 10px;
`
